import { Text } from 'basic-ui-lib';
import { RenderMedia } from 'basic-ui-lib/components/screen/RenderMedia';
import { IMediaItem } from 'modules/media/interfaces/api';
import styled from 'styled-components';

const MediaDragPreview = ({ item }: { item: IMediaItem }) => {
  return (
    <PreviewCard>
      <Content>
        {RenderMedia(item, 6, false)}
      </Content>
      <Text body_1 medium ellipsis lineClamp={1}>
        {item.name}
      </Text>
    </PreviewCard>
  );
};

export default MediaDragPreview;

const PreviewCard = styled.div`
  width: 160px;
  padding: 8px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.25);
  opacity: 0.95;
  transform: scale(1.05);
  pointer-events: none;
`;

const Content = styled.div`
  width: 100%;
  height: 90px;
  position: relative;
  border-radius: 6px;
`;